import { Link } from 'react-router-dom'
import { Button, Modal } from 'antd'
import RadioTabs from '../../../components/RadioTabs'
import Search from '../../../components/SearchFilter'
import TableAntd from '../../../components/TableAntd'
import useHook from './hooks'
import style from './style.module.scss'
import Buttonbar from '../../../components/ButtonBar'
import {
  AccountStatusKey,
  openInvoiceStateDictInvert,
} from '../../../tools/state'
import { applyForOrderTypeEnum } from '@/global/enum'
export const tipsStyle = {
  fontSize: '12px',
  color: 'rgb(226, 152, 54)',
  padding: '0 3px',
  borderRadius: '2px',
  background: 'rgb(253, 245, 233)',
  marginLeft: '10px',
}
export const tipsCancelStyle = {
  fontSize: '12px',
  color: 'rgb(64, 64, 64)',
  padding: '0 3px',
  borderRadius: '2px',
  background: 'rgb(233, 233, 233)',
  marginLeft: '10px',
}
export const tipsreturnStyle = {
  fontSize: '12px',
  color: 'red',
  padding: '0 3px',
  borderRadius: '2px',
  background: 'rgb(255, 241, 240)',
  marginLeft: '10px',
}

export default function OrderAssurance() {
  const {
    dateSource,
    handleCheckedChange,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    setOrderState,
    state,
    exportFile,
    handleTableChangeCheck,
    downloadOrder,
    handleDownLoadTableCheck,
    downLoadModalCancel,
    downLoadModalOk,
  } = useHook()
  const {
    checkedRadioKey,
    currentRadioDict,
    isTableLoading,
    pagination,
    checkGroupParam,
    downLoadModal,
    downLoadModalLoading,
    customerOrderCodeList,
    downLoadSelectedRowKeys,
  } = state

  const DownloadColumn = [
    {
      dataIndex: 'customerOrderCode',
      key: 'customerOrderCode',
      title: '客户订单号',
      width: 200,
    },
  ]

  const toAssureOperationRender = (text: any, record: any) => {
    return <Link to={`/srm/ordersupplierdetail?id=${record.id}`}>{text}</Link>
  }

  // 供应商开票状态
  const openInvoiceStateRender = (text: AccountStatusKey) => {
    const styleDict: any = {
      // 供应商已开票
      '3': {
        color: 'green',
      },
      // 供应商开票驳回
      '4': {
        color: 'red',
      },
    }
    return (
      <span style={styleDict[text]}>
        {openInvoiceStateDictInvert?.[text]?.name ?? '-'}
      </span>
    )
  }

  const listColumn = [
    {
      key: 'code',
      title: '采购订单号',
      render: toAssureOperationRender,
    },
    {
      key: 'scpShipStatusName',
      title: '订单状态',
      render: (text: any, record: any) => {
        return (
          <div>
            {text}
            {record.confirmState ? (
              <span className="normal-tag">待确认</span>
            ) : null}
            {record.cancelState ? (
              <span className="cancel-tag">有取消</span>
            ) : null}
            {record.returnState ? (
              <span className="return-tag">有退货</span>
            ) : null}
            {record.refuseState ? (
              <span className="refuse-tag">已拒绝</span>
            ) : null}
          </div>
        )
      },
      width: 120,
    },
    {
      key: 'orderType',
      title: '订单类型',
      render: (text: any) => applyForOrderTypeEnum.getLabelByValue(text) || '-',
    },
    {
      key: 'orderCreateTime',
      title: '创建时间',
    },
    {
      key: 'directShipment',
      title: '是否厂直发',
      render: (text: any) => {
        return <span>{text ? '是' : '否'}</span>
      },
    },
    {
      key: 'groupName',
      title: '采购组织',
    },
    {
      key: 'receiveMan',
      title: '收件人',
    },
    {
      key: 'number',
      title: '采购件数',
    },
    {
      key: 'price',
      title: '订单金额',
    },
    {
      key: 'warehousingProgress',
      title: '入库进度',
    },
  ]

  // 过滤table列数据
  const filterListColumn = () => {
    // 待发货tab下展示操作列
    if (['待发货'].includes(checkedRadioKey)) {
      return [
        ...listColumn,
        {
          key: 'operate',
          title: '操作',
          render: (text: string, record: any) => {
            return (
              <span
                className="primaryBtn"
                style={{ userSelect: 'none' }}
                onClick={() => downloadOrder(record)}
              >
                下载配货单
              </span>
            )
          },
        },
      ]
    } else {
      return listColumn.concat({
        key: 'supplierOpenInvoiceState',
        title: '供应商开票',
        render: openInvoiceStateRender,
      })
    }
  }

  return (
    <div>
      <Search
        fieldsData={[
          'supplierOrderCode',
          'supplierOrderGroupName',
          'supplierDirectShipment',
          'supplierOrderStartTime',
          'supplierOrderEndTime',
          'supplierOrderReceiveMan',
          'supplierOpenInvoiceState',
          'materialCode',
          'productName',
          'brand',
          'supplierOrderType',
        ]}
        onSearch={handleSearchClick}
        keyName="SUPPLIERORDERASSURANCE"
        ScreenKey="SUPPLIERORDERASSURANCE"
      />
      <div className={style['inner-content']}>
        <div className={style['tab-container']}>
          <RadioTabs
            defaultKey={checkedRadioKey}
            radioItemDict={currentRadioDict}
            onChange={handleCheckedChange}
          ></RadioTabs>
        </div>
        <div className={style.changeBtn}>
          {['待发货', '全部'].includes(checkedRadioKey) ? (
            <>
              <div
                className={
                  !checkGroupParam?.confirmState
                    ? 'filter-btn'
                    : 'filter-btn-active'
                }
                onClick={() => setOrderState('confirm')}
              >
                待确定
              </div>
              <div
                className={
                  checkGroupParam?.refuseState
                    ? 'filter-btn-active'
                    : 'filter-btn'
                }
                onClick={() => setOrderState('refuse')}
              >
                已拒绝
              </div>
            </>
          ) : null}
          <div
            className={
              checkGroupParam?.cancelState ? 'filter-btn-active' : 'filter-btn'
            }
            onClick={() => setOrderState('cancel')}
          >
            有取消
          </div>
          <div
            className={
              checkGroupParam?.returnState ? 'filter-btn-active' : 'filter-btn'
            }
            onClick={() => setOrderState('return')}
          >
            有退货
          </div>
        </div>
        <Buttonbar onRefresh={handleTableRefresh}>
          {<Button onClick={exportFile}>导出</Button>}
        </Buttonbar>
        <TableAntd
          dataSource={dateSource}
          listColumn={filterListColumn()}
          loading={isTableLoading}
          Y={420}
          pagination={{
            ...pagination,
            onChange: handlePaginationChange,
          }}
          showSize
          onChangeCheck={handleTableChangeCheck}
        ></TableAntd>
      </div>
      <Modal
        title="客户单号选择"
        open={downLoadModal}
        keyboard={false}
        maskClosable={false}
        onCancel={downLoadModalCancel}
        footer={[
          <Button
            key="confirmDownLoadModal"
            type="primary"
            onClick={downLoadModalOk}
            loading={downLoadModalLoading}
          >
            确认
          </Button>,
        ]}
      >
        <div>
          <div
            style={{ color: 'orange', fontSize: '16px', marginTop: '-20px' }}
          >
            请选择需要导出的客户订单
          </div>
          <TableAntd
            scrollCustom={{ y: 350 }}
            scrollStyle={{
              height: 'auto',
            }}
            X={150}
            dataSource={customerOrderCodeList}
            listColumn={DownloadColumn}
            onChangeCheck={handleDownLoadTableCheck}
            showSize
            rowKey="customerOrderCode"
            loading={false}
          ></TableAntd>
          <div style={{ marginTop: '15px' }}>
            已选中{downLoadSelectedRowKeys?.length}条
          </div>
        </div>
      </Modal>
    </div>
  )
}
import { Link } from 'react-router-dom'
import { Button, Modal } from 'antd'
import RadioTabs from '../../../components/RadioTabs'
import Search from '../../../components/SearchFilter'
import TableAntd from '../../../components/TableAntd'
import useHook from './hooks'
import style from './style.module.scss'
import Buttonbar from '../../../components/ButtonBar'
import {
  AccountStatusKey,
  openInvoiceStateDictInvert,
} from '../../../tools/state'
import { applyForOrderTypeEnum } from '@/global/enum'
export const tipsStyle = {
  fontSize: '12px',
  color: 'rgb(226, 152, 54)',
  padding: '0 3px',
  borderRadius: '2px',
  background: 'rgb(253, 245, 233)',
  marginLeft: '10px',
}
export const tipsCancelStyle = {
  fontSize: '12px',
  color: 'rgb(64, 64, 64)',
  padding: '0 3px',
  borderRadius: '2px',
  background: 'rgb(233, 233, 233)',
  marginLeft: '10px',
}
export const tipsreturnStyle = {
  fontSize: '12px',
  color: 'red',
  padding: '0 3px',
  borderRadius: '2px',
  background: 'rgb(255, 241, 240)',
  marginLeft: '10px',
}

export default function OrderAssurance() {
  const {
    dateSource,
    handleCheckedChange,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    setOrderState,
    state,
    exportFile,
    handleTableChangeCheck,
    downloadOrder,
    handleDownLoadTableCheck,
    downLoadModalCancel,
    downLoadModalOk,
  } = useHook()
  const {
    checkedRadioKey,
    currentRadioDict,
    isTableLoading,
    pagination,
    checkGroupParam,
    downLoadModal,
    downLoadModalLoading,
    customerOrderCodeList,
    downLoadSelectedRowKeys,
  } = state

  const DownloadColumn = [
    {
      dataIndex: 'customerOrderCode',
      key: 'customerOrderCode',
      title: '客户订单号',
      width: 200,
    },
  ]

  const toAssureOperationRender = (text: any, record: any) => {
    return <Link to={`/srm/ordersupplierdetail?id=${record.id}`}>{text}</Link>
  }

  // 供应商开票状态
  const openInvoiceStateRender = (text: AccountStatusKey) => {
    const styleDict: any = {
      // 供应商已开票
      '3': {
        color: 'green',
      },
      // 供应商开票驳回
      '4': {
        color: 'red',
      },
    }
    return (
      <span style={styleDict[text]}>
        {openInvoiceStateDictInvert?.[text]?.name ?? '-'}
      </span>
    )
  }

  const listColumn = [
    {
      key: 'code',
      title: '采购订单号',
      render: toAssureOperationRender,
    },
    {
      key: 'scpShipStatusName',
      title: '订单状态',
      render: (text: any, record: any) => {
        return (
          <div>
            {text}
            {record.confirmState ? (
              <span className="normal-tag">待确认</span>
            ) : null}
            {record.cancelState ? (
              <span className="cancel-tag">有取消</span>
            ) : null}
            {record.returnState ? (
              <span className="return-tag">有退货</span>
            ) : null}
            {record.refuseState ? (
              <span className="refuse-tag">已拒绝</span>
            ) : null}
          </div>
        )
      },
      width: 120,
    },
    {
      key: 'orderType',
      title: '订单类型',
      render: (text: any) => applyForOrderTypeEnum.getLabelByValue(text) || '-',
    },
    {
      key: 'orderCreateTime',
      title: '创建时间',
    },
    {
      key: 'directShipment',
      title: '是否厂直发',
      render: (text: any) => {
        return <span>{text ? '是' : '否'}</span>
      },
    },
    {
      key: 'groupName',
      title: '采购组织',
    },
    {
      key: 'receiveMan',
      title: '收件人',
    },
    {
      key: 'number',
      title: '采购件数',
    },
    {
      key: 'price',
      title: '订单金额',
    },
    {
      key: 'warehousingProgress',
      title: '入库进度',
    },
  ]

  // 过滤table列数据
  const filterListColumn = () => {
    // 待发货tab下展示操作列
    if (['待发货'].includes(checkedRadioKey)) {
      return [
        ...listColumn,
        {
          key: 'operate',
          title: '操作',
          render: (text: string, record: any) => {
            return (
              <span
                className="primaryBtn"
                style={{ userSelect: 'none' }}
                onClick={() => downloadOrder(record)}
              >
                下载配货单
              </span>
            )
          },
        },
      ]
    } else {
      return listColumn.concat({
        key: 'supplierOpenInvoiceState',
        title: '供应商开票',
        render: openInvoiceStateRender,
      })
    }
  }

  return (
    <div>
      <Search
        fieldsData={[
          'supplierOrderCode',
          'supplierOrderGroupName',
          'supplierDirectShipment',
          'supplierOrderStartTime',
          'supplierOrderEndTime',
          'supplierOrderReceiveMan',
          'supplierOpenInvoiceState',
          'materialCode',
          'productName',
          'brand',
          'supplierOrderType',
        ]}
        onSearch={handleSearchClick}
        keyName="SUPPLIERORDERASSURANCE"
        ScreenKey="SUPPLIERORDERASSURANCE"
      />
      <div className={style['inner-content']}>
        <div className={style['tab-container']}>
          <RadioTabs
            defaultKey={checkedRadioKey}
            radioItemDict={currentRadioDict}
            onChange={handleCheckedChange}
          ></RadioTabs>
        </div>
        <div className={style.changeBtn}>
          {['待发货', '全部'].includes(checkedRadioKey) ? (
            <>
              <div
                className={
                  !checkGroupParam?.confirmState
                    ? 'filter-btn'
                    : 'filter-btn-active'
                }
                onClick={() => setOrderState('confirm')}
              >
                待确定
              </div>
              <div
                className={
                  checkGroupParam?.refuseState
                    ? 'filter-btn-active'
                    : 'filter-btn'
                }
                onClick={() => setOrderState('refuse')}
              >
                已拒绝
              </div>
            </>
          ) : null}
          <div
            className={
              checkGroupParam?.cancelState ? 'filter-btn-active' : 'filter-btn'
            }
            onClick={() => setOrderState('cancel')}
          >
            有取消
          </div>
          <div
            className={
              checkGroupParam?.returnState ? 'filter-btn-active' : 'filter-btn'
            }
            onClick={() => setOrderState('return')}
          >
            有退货
          </div>
        </div>
        <Buttonbar onRefresh={handleTableRefresh}>
          {<Button onClick={exportFile}>导出</Button>}
        </Buttonbar>
        <TableAntd
          dataSource={dateSource}
          listColumn={filterListColumn()}
          loading={isTableLoading}
          Y={420}
          pagination={{
            ...pagination,
            onChange: handlePaginationChange,
          }}
          showSize
          onChangeCheck={handleTableChangeCheck}
        ></TableAntd>
      </div>
      <Modal
        title="客户单号选择"
        open={downLoadModal}
        keyboard={false}
        maskClosable={false}
        onCancel={downLoadModalCancel}
        footer={[
          <Button
            key="confirmDownLoadModal"
            type="primary"
            onClick={downLoadModalOk}
            loading={downLoadModalLoading}
          >
            确认
          </Button>,
        ]}
      >
        <div>
          <div
            style={{ color: 'orange', fontSize: '16px', marginTop: '-20px' }}
          >
            请选择需要导出的客户订单
          </div>
          <TableAntd
            scrollCustom={{ y: 350 }}
            scrollStyle={{
              height: 'auto',
            }}
            X={150}
            dataSource={customerOrderCodeList}
            listColumn={DownloadColumn}
            onChangeCheck={handleDownLoadTableCheck}
            showSize
            rowKey="customerOrderCode"
            loading={false}
          ></TableAntd>
          <div style={{ marginTop: '15px' }}>
            已选中{downLoadSelectedRowKeys?.length}条
          </div>
        </div>
      </Modal>
    </div>
  )
}
